import { render, staticRenderFns } from "./OptionGroupGroupBox.vue?vue&type=template&id=2a5d80e8&"
import script from "./OptionGroupGroupBox.vue?vue&type=script&lang=ts&"
export * from "./OptionGroupGroupBox.vue?vue&type=script&lang=ts&"
import style0 from "./OptionGroupGroupBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5d80e8')) {
      api.createRecord('2a5d80e8', component.options)
    } else {
      api.reload('2a5d80e8', component.options)
    }
    module.hot.accept("./OptionGroupGroupBox.vue?vue&type=template&id=2a5d80e8&", function () {
      api.rerender('2a5d80e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/OptionGroupGroupBox.vue"
export default component.exports